<div class="modal fade" id="dialogFavorecidoBusca" data-backdrop="static" data-keyboard="false" tabindex="-1"
  role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Busca de Favorecidos</h5>
        <button type="button" class="close" (click)="fechar()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2">
        <div class="row mb-3">
          <div class="col-3">
            <input [(ngModel)]="cpfCnpj" [ngModelOptions]="{standalone: true}" (keydown.enter)="buscar()" type="text"
              class="form-control" placeholder="CPF/CNPJ"
              [imask]="{mask: [ {mask: '000.000.000-00'}, {mask: '00.000.000/0000-00'} ]}" unmask="true">
          </div>
          <div class="col-9">
            <div class="input-group">
              <input [(ngModel)]="nome" (keydown.enter)="buscar()" type="text" class="form-control" placeholder="Nome">
              <div class="input-group-append" style="height: 36px;">
                <button class="btn btn-outline-secondary" (click)="buscar()" type="button">
                  <img src="assets/img/global/zoom.png" alt="Buscar" height="20" width="20">
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md">
            <table class="table table-sm table-eddy">
              <thead>
                <tr>
                  <th scope="col" class="text-center" style="min-width: 160px">CPF/CNPJ</th>
                  <th scope="col" class="w-100">Nome</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of lista">
                  <th scope="row" class="text-center">
                    <a class="btn btn-sm btn-outline-primary mr-1 mb-1" (click)="enviarFavorecido(item)">
                      {{item.cpf_cnpj | CPF}}
                    </a>
                  </th>
                  <td>
                    {{item.nome}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row float-right" *ngIf="lista && lista.length > 0">
          <div class="col-12 mb-1">
            <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
              (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-link" (click)="fechar()">Cancelar</button>
      </div>
    </div>
  </div>
</div>